import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Card, Empty, Space, Typography } from 'antd';
import { Activity, useRef, useState } from 'react';
import ProductsSlider from '../ProductsSlider';

const SuggestedProducts = ({ products, orderId }) => {
    const sliderRef = useRef(null);
    const [disabled, setDisabled] = useState({ start: true, end: false });

    const handlePositionChange = (isStart, isEnd) => {
        setDisabled({ start: isStart, end: isEnd });
    };

    return (
        <Card
            title="Suggested Products"
            classNames={{
                body: 'p-2',
            }}
            extra={
                <Activity mode={!!products?.length ? 'visible' : 'hidden'}>
                    <Space size="small">
                        <Button
                            type="default"
                            color="primary"
                            variant="filled"
                            onClick={() => sliderRef.current?.prev()}
                            icon={<LeftOutlined />}
                            disabled={disabled.start}
                        />
                        <Button
                            type="default"
                            color="primary"
                            variant="filled"
                            onClick={() => sliderRef.current?.next()}
                            icon={<RightOutlined />}
                            disabled={disabled.end}
                        />
                    </Space>
                </Activity>
            }
        >
            {!!products?.length ? (
                <ProductsSlider
                    ref={sliderRef}
                    products={products}
                    orderId={orderId}
                    onPositionChange={handlePositionChange}
                />
            ) : (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                        <Typography.Text type="secondary">No suggested products available.</Typography.Text>
                    }
                />
            )}
        </Card>
    );
};

export default SuggestedProducts;
